<template>
    <article style="position: relative;">
        <v-overlay v-model="loading" contained class="align-center justify-center" scrim="transparent" persistent>
            <v-progress-circular color="amber" indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <div v-if="links.cv && links.id">
            <h1 class="text-center m-5">View Credentials</h1>
            <div class="row text-center col-9 col-md-3 bg-body-tertiary shadow-sm rounded-2 mx-auto p-4 mb-5">
                <a :href="links.cv" target="_blank"
                    class="link-primary link-offset-2 link-underline-opacity-0 link-underline-opacity-100-hover fs-4 mb-3">
                    CV/Resume Link
                </a>
                <a :href="links.id" target="_blank"
                    class="link-primary link-offset-2 link-underline-opacity-0 link-underline-opacity-100-hover fs-4">Valid
                    ID
                    Link</a>
            </div>

            <div class="d-grid gap-2 d-sm-block text-sm-center p-3 my-5 mx-5" v-if="isAccepted === null">
                <button class="btn btn-primary btn-lg fw-semibold mx-2" style="--bs-btn-padding-x: 2rem" @click="approve">
                    Approve
                </button>

                <button class="btn btn-danger btn-lg fw-semibold mx-2" style="--bs-btn-padding-x: 2rem"
                    @click="decline">Decline
                </button>
            </div>

            <div class="d-grid gap-2 d-sm-block text-sm-center my-5 mx-5" v-else-if="isAccepted === true">
                <button class="btn btn-danger btn-lg fw-semibold mx-2" style="--bs-btn-padding-x: 2rem"
                    @click="decline">Decline
                </button>
            </div>

            <div v-else class="d-grid gap-2 d-sm-block text-sm-center my-5 mx-5">
                <button class="btn btn-primary btn-lg fw-semibold mx-2" style="--bs-btn-padding-x: 2rem" @click="approve">
                    Approve
                </button>
            </div>
        </div>

        <div v-else>
            <h1 class="text-center m-5">Volunter data not found</h1>
        </div>
    </article>
</template>

<script>
import { ref, reactive, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getDoc, doc, updateDoc, query, where, getDocs, collection } from 'firebase/firestore'
import { db } from "@/firebase"
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default {
    setup() {
        const router = useRouter()
        const route = useRoute()
        const volunteerId = computed(() => route.params.id)
        const isAccepted = ref()
        const links = reactive({ cv: '', id: '' })
        const loading = ref(true)

        // Get volunteer data if it exists
        const getVolunteer = async (volunteerId) => {
            const volunteer = await getDoc(doc(db, 'Volunteer Applications', volunteerId))
            loading.value = false // Hide loading once done fetching data
            return volunteer.exists ? volunteer.data() : null
        }

        onMounted(async () => {
            const volunteer = await getVolunteer(volunteerId.value)

            // Assign values only if volunteer exists
            if (volunteer) {
                links.cv = volunteer.CvURL
                links.id = volunteer.ValidIdUrl
                isAccepted.value = volunteer.IsAccepted
            }
        })

        const approve = async () => {
            await updateDoc(doc(db, "Volunteer Applications", volunteerId.value), {
                IsAccepted: true
            })

            toast.success("Volunteer sucessfully approved", {
                autoClose: 2000,
            })

            if (isAccepted.value === null) {
                router.push('/volunteers')
            } else {
                router.push('/declined-volunteers')
            }
        }

        const decline = async () => {
            await updateDoc(doc(db, "Volunteer Applications", volunteerId.value), {
                IsAccepted: false
            })


            // Make event main host to null if main host's application is declined
            const q = query(collection(db, "Events"),
                where("MainHost", "==", volunteerId.value),
                where("IsArchived", "==", false));

            const querySnapshot = await getDocs(q);
            querySnapshot.forEach(async (doc) => {
                const docRef = doc.ref;
                await updateDoc(docRef, {
                    MainHost: null
                })
            })

            toast.success("Volunteer sucessfully declined", {
                autoClose: 2000,
            })


            if (isAccepted.value === null) {
                router.push('/volunteers')
            } else {
                router.push('/approved-volunteers')
            }
        }

        return { approve, decline, links, isAccepted, loading }
    }
}
</script>

<style scoped src="@/assets/css/admin.css"></style>